import type {
  RelationshipCommentCreateRequestType,
  RelationshipCommentCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRelationshipCommentCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: RelationshipCommentCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `relationship-comments`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as RelationshipCommentCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.MessageInbox],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.RelationshipComments,
        ],
      });
    },
  });
};
